import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { axiosIns } from './axios.config';
import { Cookies } from 'react-cookie';
import { attachApiErrorToastInterceptor } from '../utils/api-error-toast';

export const axiosTokenInst = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_CARTITEM_URL,
});
attachApiErrorToastInterceptor(axiosTokenInst);
axiosIns.interceptors.request.use((config) => {
  config.baseURL = process.env.REACT_APP_API_BASE_CARTITEM_URL;
  return config;
});
export const cartItemService = async ({ residparams, menuparams, quantityparams, idparams, noteparams }: any) => {
  try {
    if (process.env.REACT_APP_API_BASE_CARTITEM_URL) {
      const cookies = new Cookies();
      const token = cookies.get('session_token');
      const response = await axios.post(
        process.env.REACT_APP_API_BASE_CARTITEM_URL,
        {
          restaurant_id: residparams,
          menu_item_id: menuparams,
          quantity: quantityparams,
          addon_level_ids: idparams,
          note: noteparams,
        },

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data;
    }
  } catch (error: any) {
    return Promise.reject(error);
  }
};

export const useCartItemService = (
  residparams: number,
  menuparams: number,
  quantityparams: number,
  idparams: any,
  noteparams: string,
  enable: boolean,
) => {
  return useQuery({
    enabled: enable,
    queryKey: ['cartItem-service'],
    queryFn: () =>
      cartItemService({
        residparams: residparams,
        menuparams: menuparams,
        quantityparams: quantityparams,
        idparams: idparams,
        noteparams: noteparams,
      }),
  });
};

export const cartItemServicePatch = async (id: any, quantityparam: number, noteparam: string, levelparam: any) => {
  try {
    const cookies = new Cookies();
    const token = cookies.get('session_token');
    return await axiosTokenInst.patch(
      `${id}`,
      {
        quantity: quantityparam,
        note: noteparam,
        addon_level_ids: levelparam,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  } catch (error) {
    return Promise.reject(error);
  }
};

export const useCartItemServicePatch = (
  id: any,
  enable: boolean,
  quantityparams: number,
  notes: string,
  levelidparams: any,
) => {
  return useQuery({
    enabled: enable,
    queryKey: ['cartitempatch-service', id, quantityparams, notes, levelidparams],
    queryFn: () => cartItemServicePatch(id, quantityparams, notes, levelidparams),
  });
};

export const cartItemServiceDel = async (params: any) => {
  try {
    const cookies = new Cookies();
    const token = cookies.get('session_token');
    return await axiosTokenInst.delete(`${params}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const useCartItemServiceDel = (params: any, enable: boolean) => {
  return useQuery({
    enabled: enable,
    queryKey: ['cartitemdel-service', params],
    queryFn: () => cartItemServiceDel(params),
  });
};
